export var DEPLOY_DATE = new Date('2026-10-08T17:11:21+0000');
